import { SpokenItem } from "@/components/items/SpokenItem";
import { LineItem } from "@/components/items/LineItem";
import { TypingItem } from "@/components/items/TypingItem";
import { ReconstructItem } from "@/components/items/ReconstructItem";
import { SummaryItem } from "@/components/items/SummaryItem";

const MAP = { speak: SpokenItem, line: LineItem, typing: TypingItem, reconstruct: ReconstructItem, summary: SummaryItem };

export const ItemRenderer = (props) => {
  const C = MAP[props.part.kind];
  return <C {...props} />;
};
